import { render, staticRenderFns } from "./panoramaPage.vue?vue&type=template&id=60fb3011&scoped=true&"
import script from "./panoramaPage.vue?vue&type=script&lang=js&"
export * from "./panoramaPage.vue?vue&type=script&lang=js&"
import style0 from "./panoramaPage.vue?vue&type=style&index=0&id=60fb3011&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fb3011",
  null
  
)

export default component.exports